/** Mirrors Android `SqsEvents.trackingSourceList`. */
export const trackingSourceList = {
    Il_website: "IL Website",
    il_surge: "IL Surge",
    learn_an: "Learn AN",
    inbound_call: "Inbound Call",
    whatsapp_chat: "WhatsApp Chat",
    marketing_pages: "Marketing Pages",
    career360: "Careers360",
    international_leads: "International Leads",
    inmobius_leads: "InMobius Leads",
    performance_marketing: "Performance Marketing",
    brand_lead: "Brand Lead",
    external_database: "External Database",
    inmobius_offline: "Inmobius Offline",
    database_marketing: "Database Marketing",
    brand_leads: "Brand Lead",
};
